import SaveOutlined from "@mui/icons-material/SaveOutlined";
import { Button } from "@mui/material";
import { ReactNode } from "react";

export type SaveButtonProps = {
  loading?: boolean;
  loadingText?: string;
  disabled?: boolean;
  endIcon?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  saveText?: string;
  startIcon?: ReactNode;
  hideStartIcon?: boolean;
  formId?: string;
};

export const SaveButton: React.FC<SaveButtonProps> = ({
  loading: isLoading,
  loadingText = "Saving...",
  disabled: isDisabled,
  onClick,
  formId,
  saveText = "Save",
  startIcon = <SaveOutlined />,
  hideStartIcon,
  endIcon,
}) => {
  return (
    <Button
      type="submit"
      variant="contained"
      disabled={isDisabled || isLoading}
      startIcon={!hideStartIcon && !isLoading && startIcon}
      endIcon={endIcon && !isLoading ? endIcon : undefined}
      onClick={onClick}
      form={formId}
    >
      {isLoading ? loadingText : saveText}
    </Button>
  );
};
